import React, { createContext, useContext, useEffect, useState } from "react";

const UnitsContext = createContext(null);
const KEY = "ckd_units_pref";

export function UnitsProvider({ children }) {
  const [units, setUnits] = useState(() => localStorage.getItem(KEY) || "US");

  useEffect(() => {
    localStorage.setItem(KEY, units);
  }, [units]);

  const toggle = () => setUnits((u) => (u === "US" ? "SI" : "US"));

  return (
    <UnitsContext.Provider value={{ units, setUnits, toggle }}>
      {children}
    </UnitsContext.Provider>
  );
}

export const useUnits = () => useContext(UnitsContext);

// Conversions
export const CREAT_US_TO_SI = 88.4; // mg/dL -> µmol/L
export const CREAT_SI_TO_US = 1 / CREAT_US_TO_SI;

export function creatinineDisplay(mg_dl, units) {
  if (mg_dl == null || isNaN(mg_dl)) return "";
  if (units === "SI") return (mg_dl * CREAT_US_TO_SI).toFixed(1);
  return Number(mg_dl).toFixed(2);
}

export function creatinineUnitLabel(units) {
  return units === "SI" ? "µmol/L" : "mg/dL";
}

// Weight helpers — storage is always kg, display flips with the units toggle.
export const KG_PER_LB = 0.45359237;

export function weightUnitLabel(units) {
  return units === "SI" ? "kg" : "lb";
}

// Given kg-stored value, return the display value for the current units (rounded to 1 decimal).
export function weightDisplay(kg, units) {
  if (kg == null || isNaN(kg)) return "";
  const v = units === "SI" ? kg : kg / KG_PER_LB;
  return Number(v).toFixed(1);
}

// Given a display value in the current units, return the kg value to store.
export function weightToKg(displayVal, units) {
  if (displayVal === "" || displayVal == null || isNaN(displayVal)) return null;
  const n = parseFloat(displayVal);
  return units === "SI" ? n : n * KG_PER_LB;
}
